import script from "./meLandProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./meLandProduct.vue?vue&type=script&setup=true&lang=js"

import "./meLandProduct.vue?vue&type=style&index=0&id=2d1367da&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1367da"]])

export default __exports__